/*
File generated by js-routes 1.4.9
Based on Rails 6.0.6.1 routes of Basedia::Application
 */

(function() {
  var DeprecatedGlobbingBehavior, NodeTypes, ParameterMissing, ReservedOptions, SpecialOptionsKey, UriEncoderSegmentRegex, Utils, result, root,
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  ParameterMissing = function(message, fileName, lineNumber) {
    var instance;
    instance = new Error(message, fileName, lineNumber);
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    } else {
      instance.__proto__ = this.__proto__;
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, ParameterMissing);
    }
    return instance;
  };

  ParameterMissing.prototype = Object.create(Error.prototype, {
    constructor: {
      value: Error,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ParameterMissing, Error);
  } else {
    ParameterMissing.__proto__ = Error;
  }

  NodeTypes = {"GROUP":1,"CAT":2,"SYMBOL":3,"OR":4,"STAR":5,"LITERAL":6,"SLASH":7,"DOT":8};

  DeprecatedGlobbingBehavior = false;

  SpecialOptionsKey = "_options";

  UriEncoderSegmentRegex = /[^a-zA-Z0-9\-\._~!\$&'\(\)\*\+,;=:@]/g;

  ReservedOptions = ['anchor', 'trailing_slash', 'subdomain', 'host', 'port', 'protocol'];

  Utils = {
    configuration: {
      prefix: "",
      default_url_options: {},
      special_options_key: "_options",
      serializer: null
    },
    default_serializer: function(object, prefix) {
      var element, i, j, key, len, prop, s;
      if (prefix == null) {
        prefix = null;
      }
      if (object == null) {
        return "";
      }
      if (!prefix && !(this.get_object_type(object) === "object")) {
        throw new Error("Url parameters should be a javascript hash");
      }
      s = [];
      switch (this.get_object_type(object)) {
        case "array":
          for (i = j = 0, len = object.length; j < len; i = ++j) {
            element = object[i];
            s.push(this.default_serializer(element, prefix + "[]"));
          }
          break;
        case "object":
          for (key in object) {
            if (!hasProp.call(object, key)) continue;
            prop = object[key];
            if ((prop == null) && (prefix != null)) {
              prop = "";
            }
            if (prop != null) {
              if (prefix != null) {
                key = prefix + "[" + key + "]";
              }
              s.push(this.default_serializer(prop, key));
            }
          }
          break;
        default:
          if (object != null) {
            s.push((encodeURIComponent(prefix.toString())) + "=" + (encodeURIComponent(object.toString())));
          }
      }
      if (!s.length) {
        return "";
      }
      return s.join("&");
    },
    serialize: function(object) {
      var custom_serializer;
      custom_serializer = this.configuration.serializer;
      if ((custom_serializer != null) && this.get_object_type(custom_serializer) === "function") {
        return custom_serializer(object);
      } else {
        return this.default_serializer(object);
      }
    },
    clean_path: function(path) {
      var last_index;
      path = path.split("://");
      last_index = path.length - 1;
      path[last_index] = path[last_index].replace(/\/+/g, "/");
      return path.join("://");
    },
    extract_options: function(number_of_params, args) {
      var last_el, options;
      last_el = args[args.length - 1];
      if ((args.length > number_of_params && last_el === void 0) || ((last_el != null) && "object" === this.get_object_type(last_el) && !this.looks_like_serialized_model(last_el))) {
        options = args.pop() || {};
        delete options[this.configuration.special_options_key];
        return options;
      } else {
        return {};
      }
    },
    looks_like_serialized_model: function(object) {
      return !object[this.configuration.special_options_key] && ("id" in object || "to_param" in object);
    },
    path_identifier: function(object) {
      var property;
      if (object === 0) {
        return "0";
      }
      if (!object) {
        return "";
      }
      property = object;
      if (this.get_object_type(object) === "object") {
        if ("to_param" in object) {
          if (object.to_param == null) {
            throw new ParameterMissing("Route parameter missing: to_param");
          }
          property = object.to_param;
        } else if ("id" in object) {
          if (object.id == null) {
            throw new ParameterMissing("Route parameter missing: id");
          }
          property = object.id;
        } else {
          property = object;
        }
        if (this.get_object_type(property) === "function") {
          property = property.call(object);
        }
      }
      return property.toString();
    },
    clone: function(obj) {
      var attr, copy, key;
      if ((obj == null) || "object" !== this.get_object_type(obj)) {
        return obj;
      }
      copy = obj.constructor();
      for (key in obj) {
        if (!hasProp.call(obj, key)) continue;
        attr = obj[key];
        copy[key] = attr;
      }
      return copy;
    },
    merge: function() {
      var tap, xs;
      xs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      tap = function(o, fn) {
        fn(o);
        return o;
      };
      if ((xs != null ? xs.length : void 0) > 0) {
        return tap({}, function(m) {
          var j, k, len, results, v, x;
          results = [];
          for (j = 0, len = xs.length; j < len; j++) {
            x = xs[j];
            results.push((function() {
              var results1;
              results1 = [];
              for (k in x) {
                v = x[k];
                results1.push(m[k] = v);
              }
              return results1;
            })());
          }
          return results;
        });
      }
    },
    normalize_options: function(parts, required_parts, default_options, actual_parameters) {
      var i, j, key, len, options, part, parts_options, result, route_parts, url_parameters, use_all_parts, value;
      options = this.extract_options(parts.length, actual_parameters);
      if (actual_parameters.length > parts.length) {
        throw new Error("Too many parameters provided for path");
      }
      use_all_parts = actual_parameters.length > required_parts.length;
      parts_options = {};
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        use_all_parts = true;
        if (this.indexOf(parts, key) >= 0) {
          parts_options[key] = value;
        }
      }
      options = this.merge(this.configuration.default_url_options, default_options, options);
      result = {};
      url_parameters = {};
      result['url_parameters'] = url_parameters;
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        value = options[key];
        if (this.indexOf(ReservedOptions, key) >= 0) {
          result[key] = value;
        } else {
          url_parameters[key] = value;
        }
      }
      route_parts = use_all_parts ? parts : required_parts;
      i = 0;
      for (j = 0, len = route_parts.length; j < len; j++) {
        part = route_parts[j];
        if (i < actual_parameters.length) {
          if (!parts_options.hasOwnProperty(part)) {
            url_parameters[part] = actual_parameters[i];
            ++i;
          }
        }
      }
      return result;
    },
    build_route: function(parts, required_parts, default_options, route, full_url, args) {
      var options, parameters, result, url, url_params;
      args = Array.prototype.slice.call(args);
      options = this.normalize_options(parts, required_parts, default_options, args);
      parameters = options['url_parameters'];
      result = "" + (this.get_prefix()) + (this.visit(route, parameters));
      url = Utils.clean_path(result);
      if (options['trailing_slash'] === true) {
        url = url.replace(/(.*?)[\/]?$/, "$1/");
      }
      if ((url_params = this.serialize(parameters)).length) {
        url += "?" + url_params;
      }
      url += options.anchor ? "#" + options.anchor : "";
      if (full_url) {
        url = this.route_url(options) + url;
      }
      return url;
    },
    visit: function(route, parameters, optional) {
      var left, left_part, right, right_part, type, value;
      if (optional == null) {
        optional = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return this.visit(left, parameters, true);
        case NodeTypes.STAR:
          return this.visit_globbing(left, parameters, true);
        case NodeTypes.LITERAL:
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
          return left;
        case NodeTypes.CAT:
          left_part = this.visit(left, parameters, optional);
          right_part = this.visit(right, parameters, optional);
          if (optional && ((this.is_optional_node(left[0]) && !left_part) || ((this.is_optional_node(right[0])) && !right_part))) {
            return "";
          }
          return "" + left_part + right_part;
        case NodeTypes.SYMBOL:
          value = parameters[left];
          delete parameters[left];
          if (value != null) {
            return this.encode_segment(this.path_identifier(value));
          }
          if (optional) {
            return "";
          } else {
            throw new ParameterMissing("Route parameter missing: " + left);
          }
          break;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    encode_segment: function(segment) {
      return segment.replace(UriEncoderSegmentRegex, function(str) {
        return encodeURIComponent(str);
      });
    },
    is_optional_node: function(node) {
      return this.indexOf([NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT], node) >= 0;
    },
    build_path_spec: function(route, wildcard) {
      var left, right, type;
      if (wildcard == null) {
        wildcard = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return "(" + (this.build_path_spec(left)) + ")";
        case NodeTypes.CAT:
          return "" + (this.build_path_spec(left)) + (this.build_path_spec(right));
        case NodeTypes.STAR:
          return this.build_path_spec(left, true);
        case NodeTypes.SYMBOL:
          if (wildcard === true) {
            return "" + (left[0] === '*' ? '' : '*') + left;
          } else {
            return ":" + left;
          }
          break;
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
        case NodeTypes.LITERAL:
          return left;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    visit_globbing: function(route, parameters, optional) {
      var left, right, type, value;
      type = route[0], left = route[1], right = route[2];
      value = parameters[left];
      delete parameters[left];
      if (value == null) {
        return this.visit(route, parameters, optional);
      }
      value = (function() {
        switch (this.get_object_type(value)) {
          case "array":
            return value.join("/");
          default:
            return value;
        }
      }).call(this);
      if (DeprecatedGlobbingBehavior) {
        return this.path_identifier(value);
      } else {
        return encodeURI(this.path_identifier(value));
      }
    },
    get_prefix: function() {
      var prefix;
      prefix = this.configuration.prefix;
      if (prefix !== "") {
        prefix = (prefix.match("/$") ? prefix : prefix + "/");
      }
      return prefix;
    },
    route: function(parts_table, default_options, route_spec, full_url) {
      var j, len, part, parts, path_fn, ref, required, required_parts;
      required_parts = [];
      parts = [];
      for (j = 0, len = parts_table.length; j < len; j++) {
        ref = parts_table[j], part = ref[0], required = ref[1];
        parts.push(part);
        if (required) {
          required_parts.push(part);
        }
      }
      path_fn = function() {
        return Utils.build_route(parts, required_parts, default_options, route_spec, full_url, arguments);
      };
      path_fn.required_params = required_parts;
      path_fn.toString = function() {
        return Utils.build_path_spec(route_spec);
      };
      return path_fn;
    },
    route_url: function(route_defaults) {
      var hostname, port, protocol, subdomain;
      if (typeof route_defaults === 'string') {
        return route_defaults;
      }
      hostname = route_defaults.host || Utils.current_host();
      if (!hostname) {
        return '';
      }
      subdomain = route_defaults.subdomain ? route_defaults.subdomain + '.' : '';
      protocol = route_defaults.protocol || Utils.current_protocol();
      port = route_defaults.port || (!route_defaults.host ? Utils.current_port() : void 0);
      port = port ? ":" + port : '';
      return protocol + "://" + subdomain + hostname + port;
    },
    has_location: function() {
      return (typeof window !== "undefined" && window !== null ? window.location : void 0) != null;
    },
    current_host: function() {
      if (this.has_location()) {
        return window.location.hostname;
      } else {
        return null;
      }
    },
    current_protocol: function() {
      if (this.has_location() && window.location.protocol !== '') {
        return window.location.protocol.replace(/:$/, '');
      } else {
        return 'http';
      }
    },
    current_port: function() {
      if (this.has_location() && window.location.port !== '') {
        return window.location.port;
      } else {
        return '';
      }
    },
    _classToTypeCache: null,
    _classToType: function() {
      var j, len, name, ref;
      if (this._classToTypeCache != null) {
        return this._classToTypeCache;
      }
      this._classToTypeCache = {};
      ref = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
      for (j = 0, len = ref.length; j < len; j++) {
        name = ref[j];
        this._classToTypeCache["[object " + name + "]"] = name.toLowerCase();
      }
      return this._classToTypeCache;
    },
    get_object_type: function(obj) {
      if (root.jQuery && (root.jQuery.type != null)) {
        return root.jQuery.type(obj);
      }
      if (obj == null) {
        return "" + obj;
      }
      if (typeof obj === "object" || typeof obj === "function") {
        return this._classToType()[Object.prototype.toString.call(obj)] || "object";
      } else {
        return typeof obj;
      }
    },
    indexOf: function(array, element) {
      if (Array.prototype.indexOf) {
        return array.indexOf(element);
      } else {
        return this.indexOfImplementation(array, element);
      }
    },
    indexOfImplementation: function(array, element) {
      var el, i, j, len, result;
      result = -1;
      for (i = j = 0, len = array.length; j < len; i = ++j) {
        el = array[i];
        if (el === element) {
          result = i;
        }
      }
      return result;
    },
    namespace: function(root, namespace, routes) {
      var index, j, len, part, parts;
      parts = namespace ? namespace.split(".") : [];
      if (parts.length === 0) {
        return routes;
      }
      for (index = j = 0, len = parts.length; j < len; index = ++j) {
        part = parts[index];
        if (index < parts.length - 1) {
          root = (root[part] || (root[part] = {}));
        } else {
          return root[part] = routes;
        }
      }
    },
    configure: function(new_config) {
      return this.configuration = this.merge(this.configuration, new_config);
    },
    config: function() {
      return this.clone(this.configuration);
    },
    make: function() {
      var routes;
      routes = {
// accept_v1_admin_subscription_request => /v1/admin/subscription_requests/:id/accept(.:format)
  // function(id, options)
  accept_v1_admin_subscription_request_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"accept",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// accept_with_password_v1_admin_subscription_request => /v1/admin/subscription_requests/:id/accept_with_password(.:format)
  // function(id, options)
  accept_with_password_v1_admin_subscription_request_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"accept_with_password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// clear_custom_ids_v1_database_surveys => /v1/databases/:database_id/surveys/clear_custom_ids(.:format)
  // function(database_id, options)
  clear_custom_ids_v1_database_surveys_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[6,"clear_custom_ids",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// clone_to_database_v1_admin_group => /v1/admin/groups/:id/clone_to_database(.:format)
  // function(id, options)
  clone_to_database_v1_admin_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"clone_to_database",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// clone_v1_admin_group => /v1/admin/groups/:id/clone(.:format)
  // function(id, options)
  clone_v1_admin_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"clone",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// confirm_with_password => /confirmations/with_password(.:format)
  // function(options)
  confirm_with_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"confirmations",false],[2,[7,"/",false],[2,[6,"with_password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// confirmation => /confirmation(.:format)
  // function(options)
  confirmation_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"confirmation",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// confirmation_with_password => /confirmation(.:format)
  // function(options)
  confirmation_with_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"confirmation",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// destroy_user_session => /v1/logout(.:format)
  // function(options)
  destroy_user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"logout",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// dump_v1_database_surveys => /v1/databases/:database_id/surveys/dump(.:format)
  // function(database_id, options)
  dump_v1_database_surveys_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[6,"dump",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_user_password => /v1/password/edit(.:format)
  // function(options)
  edit_user_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// edit_v1_admin_group => /v1/admin/groups/:id/edit(.:format)
  // function(id, options)
  edit_v1_admin_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_v1_admin_question => /v1/admin/questions/:id/edit(.:format)
  // function(id, options)
  edit_v1_admin_question_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"questions",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_v1_admin_question_template => /v1/admin/question_templates/:id/edit(.:format)
  // function(id, options)
  edit_v1_admin_question_template_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"question_templates",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// edit_v1_answers_group => /v1/answers_groups/:id/edit(.:format)
  // function(id, options)
  edit_v1_answers_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"answers_groups",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// edit_v1_survey => /v1/surveys/:id/edit(.:format)
  // function(id, options)
  edit_v1_survey_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"edit",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// forgot_password => /forgot_password(.:format)
  // function(options)
  forgot_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"forgot_password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// mass_create_v1_admin_database_database_supervisors => /v1/admin/databases/:database_id/database_supervisors/mass_create(.:format)
  // function(database_id, options)
  mass_create_v1_admin_database_database_supervisors_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_supervisors",false],[2,[7,"/",false],[2,[6,"mass_create",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// mass_create_v1_admin_database_database_users => /v1/admin/databases/:database_id/database_users/mass_create(.:format)
  // function(database_id, options)
  mass_create_v1_admin_database_database_users_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_users",false],[2,[7,"/",false],[2,[6,"mass_create",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// new_user_confirmation => /v1/confirmation/new(.:format)
  // function(options)
  new_user_confirmation_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"confirmation",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_user_password => /v1/password/new(.:format)
  // function(options)
  new_user_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// new_user_session => /v1/login(.:format)
  // function(options)
  new_user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"login",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// new_v1_admin_database_group => /v1/admin/databases/:database_id/groups/new(.:format)
  // function(database_id, options)
  new_v1_admin_database_group_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// new_v1_admin_database_template_question_template => /v1/admin/databases/:database_id/templates/:template_id/question_templates/new(.:format)
  // function(database_id, template_id, options)
  new_v1_admin_database_template_question_template_path: Utils.route([["database_id",true],["template_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[2,[7,"/",false],[2,[3,"template_id",false],[2,[7,"/",false],[2,[6,"question_templates",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]]]]]),
// new_v1_admin_group_question => /v1/admin/groups/:group_id/questions/new(.:format)
  // function(group_id, options)
  new_v1_admin_group_question_path: Utils.route([["group_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"group_id",false],[2,[7,"/",false],[2,[6,"questions",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// new_v1_database_survey => /v1/databases/:database_id/surveys/new(.:format)
  // function(database_id, options)
  new_v1_database_survey_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// new_v1_survey_answers_group => /v1/surveys/:survey_id/answers_groups/new(.:format)
  // function(survey_id, options)
  new_v1_survey_answers_group_path: Utils.route([["survey_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[3,"survey_id",false],[2,[7,"/",false],[2,[6,"answers_groups",false],[2,[7,"/",false],[2,[6,"new",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// notifications_v1_admin_database_database_user => /v1/admin/databases/:database_id/database_users/:id/notifications(.:format)
  // function(database_id, id, options)
  notifications_v1_admin_database_database_user_path: Utils.route([["database_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"notifications",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]]]),
// passwords_forgot => /passwords_forgot(.:format)
  // function(options)
  passwords_forgot_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"passwords_forgot",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// passwords_reset => /passwords_reset(.:format)
  // function(options)
  passwords_reset_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"passwords_reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// pause_v1_therapy => /v1/therapies/:id/pause(.:format)
  // function(id, options)
  pause_v1_therapy_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"therapies",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"pause",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// privacy => /privacy(.:format)
  // function(options)
  privacy_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"privacy",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// providers_v1_admin_databases => /v1/admin/databases/providers(.:format)
  // function(options)
  providers_v1_admin_databases_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[6,"providers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// rails_blob_representation => /rails/active_storage/representations/:signed_blob_id/:variation_key/*filename(.:format)
  // function(signed_blob_id, variation_key, filename, options)
  rails_blob_representation_path: Utils.route([["signed_blob_id",true],["variation_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"representations",false],[2,[7,"/",false],[2,[3,"signed_blob_id",false],[2,[7,"/",false],[2,[3,"variation_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// rails_direct_uploads => /rails/active_storage/direct_uploads(.:format)
  // function(options)
  rails_direct_uploads_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"direct_uploads",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// rails_disk_service => /rails/active_storage/disk/:encoded_key/*filename(.:format)
  // function(encoded_key, filename, options)
  rails_disk_service_path: Utils.route([["encoded_key",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_key",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// rails_service_blob => /rails/active_storage/blobs/:signed_id/*filename(.:format)
  // function(signed_id, filename, options)
  rails_service_blob_path: Utils.route([["signed_id",true],["filename",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"blobs",false],[2,[7,"/",false],[2,[3,"signed_id",false],[2,[7,"/",false],[2,[5,[3,"filename",false],false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// reject_v1_admin_subscription_request => /v1/admin/subscription_requests/:id/reject(.:format)
  // function(id, options)
  reject_v1_admin_subscription_request_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"reject",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// reset_password => /reset_password(.:format)
  // function(options)
  reset_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"reset_password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// reset_password_v1_admin_user => /v1/admin/users/:id/reset_password(.:format)
  // function(id, options)
  reset_password_v1_admin_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"reset_password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// resume_v1_therapy => /v1/therapies/:id/resume(.:format)
  // function(id, options)
  resume_v1_therapy_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"therapies",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"resume",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// revoke_consent_v1_patient => /v1/patients/:id/revoke_consent(.:format)
  // function(id, options)
  revoke_consent_v1_patient_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"patients",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"revoke_consent",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// root => /
  // function(options)
  root_path: Utils.route([], {}, [7,"/",false]),
// send_test_email_v1_notifications => /v1/notifications/send_test_email(.:format)
  // function(options)
  send_test_email_v1_notifications_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"notifications",false],[2,[7,"/",false],[2,[6,"send_test_email",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// update_image_v1_admin_database => /v1/admin/databases/:id/update_image(.:format)
  // function(id, options)
  update_image_v1_admin_database_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"update_image",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// update_rails_disk_service => /rails/active_storage/disk/:encoded_token(.:format)
  // function(encoded_token, options)
  update_rails_disk_service_path: Utils.route([["encoded_token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"rails",false],[2,[7,"/",false],[2,[6,"active_storage",false],[2,[7,"/",false],[2,[6,"disk",false],[2,[7,"/",false],[2,[3,"encoded_token",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// user_confirmation => /v1/confirmation(.:format)
  // function(options)
  user_confirmation_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"confirmation",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// user_password => /v1/password(.:format)
  // function(options)
  user_password_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// user_session => /v1/login(.:format)
  // function(options)
  user_session_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"login",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1 => /v1/databases/by_uuid/:uuid(.:format)
  // function(uuid, options)
  v1_path: Utils.route([["uuid",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[6,"by_uuid",false],[2,[7,"/",false],[2,[3,"uuid",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_account => /v1/account(.:format)
  // function(options)
  v1_account_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"account",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_admin_database => /v1/admin/databases/:id(.:format)
  // function(id, options)
  v1_admin_database_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_database_database_supervisor => /v1/admin/databases/:database_id/database_supervisors/:id(.:format)
  // function(database_id, id, options)
  v1_admin_database_database_supervisor_path: Utils.route([["database_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_supervisors",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// v1_admin_database_database_supervisors => /v1/admin/databases/:database_id/database_supervisors(.:format)
  // function(database_id, options)
  v1_admin_database_database_supervisors_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_supervisors",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_admin_database_database_user => /v1/admin/databases/:database_id/database_users/:id(.:format)
  // function(database_id, id, options)
  v1_admin_database_database_user_path: Utils.route([["database_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_users",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// v1_admin_database_database_users => /v1/admin/databases/:database_id/database_users(.:format)
  // function(database_id, options)
  v1_admin_database_database_users_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"database_users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_admin_database_groups => /v1/admin/databases/:database_id/groups(.:format)
  // function(database_id, options)
  v1_admin_database_groups_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"groups",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_admin_database_template => /v1/admin/databases/:database_id/templates/:id(.:format)
  // function(database_id, id, options)
  v1_admin_database_template_path: Utils.route([["database_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]),
// v1_admin_database_template_question_templates => /v1/admin/databases/:database_id/templates/:template_id/question_templates(.:format)
  // function(database_id, template_id, options)
  v1_admin_database_template_question_templates_path: Utils.route([["database_id",true],["template_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[2,[7,"/",false],[2,[3,"template_id",false],[2,[7,"/",false],[2,[6,"question_templates",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]]]]),
// v1_admin_database_templates => /v1/admin/databases/:database_id/templates(.:format)
  // function(database_id, options)
  v1_admin_database_templates_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_admin_databases => /v1/admin/databases(.:format)
  // function(options)
  v1_admin_databases_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_admin_group => /v1/admin/groups/:id(.:format)
  // function(id, options)
  v1_admin_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_group_questions => /v1/admin/groups/:group_id/questions(.:format)
  // function(group_id, options)
  v1_admin_group_questions_path: Utils.route([["group_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"groups",false],[2,[7,"/",false],[2,[3,"group_id",false],[2,[7,"/",false],[2,[6,"questions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_admin_question => /v1/admin/questions/:id(.:format)
  // function(id, options)
  v1_admin_question_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"questions",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_question_template => /v1/admin/question_templates/:id(.:format)
  // function(id, options)
  v1_admin_question_template_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"question_templates",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_questions => /v1/admin/questions(.:format)
  // function(options)
  v1_admin_questions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"questions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_admin_subscription_request => /v1/admin/subscription_requests/:id(.:format)
  // function(id, options)
  v1_admin_subscription_request_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_subscription_requests => /v1/admin/subscription_requests(.:format)
  // function(options)
  v1_admin_subscription_requests_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_admin_trigger_daily_notifications => /v1/admin/trigger_daily_notifications(.:format)
  // function(options)
  v1_admin_trigger_daily_notifications_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"trigger_daily_notifications",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_admin_trigger_dispatch => /v1/admin/trigger_dispatch(.:format)
  // function(options)
  v1_admin_trigger_dispatch_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"trigger_dispatch",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_admin_user => /v1/admin/users/:id(.:format)
  // function(id, options)
  v1_admin_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_admin_users => /v1/admin/users(.:format)
  // function(options)
  v1_admin_users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_answer => /v1/answers/:id(.:format)
  // function(id, options)
  v1_answer_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"answers",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_answers_group => /v1/answers_groups/:id(.:format)
  // function(id, options)
  v1_answers_group_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"answers_groups",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_answers_group_answers => /v1/answers_groups/:answers_group_id/answers(.:format)
  // function(answers_group_id, options)
  v1_answers_group_answers_path: Utils.route([["answers_group_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"answers_groups",false],[2,[7,"/",false],[2,[3,"answers_group_id",false],[2,[7,"/",false],[2,[6,"answers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_current_user => /v1/current_user(.:format)
  // function(options)
  v1_current_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"current_user",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_database => /v1/databases/:id(.:format)
  // function(id, options)
  v1_database_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_database_patients => /v1/databases/:database_id/patients(.:format)
  // function(database_id, options)
  v1_database_patients_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"patients",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_database_supervisor => /v1/database_supervisors/:id(.:format)
  // function(id, options)
  v1_database_supervisor_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"database_supervisors",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_database_supervisors => /v1/database_supervisors(.:format)
  // function(options)
  v1_database_supervisors_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"database_supervisors",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_database_surveys => /v1/databases/:database_id/surveys(.:format)
  // function(database_id, options)
  v1_database_surveys_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"surveys",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_database_template => /v1/databases/:database_id/templates/:id(.:format)
  // function(database_id, id, options)
  v1_database_template_path: Utils.route([["database_id",true],["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_database_templates => /v1/databases/:database_id/templates(.:format)
  // function(database_id, options)
  v1_database_templates_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"templates",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_database_user => /v1/database_users/:id(.:format)
  // function(id, options)
  v1_database_user_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"database_users",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_database_users => /v1/database_users(.:format)
  // function(options)
  v1_database_users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"database_users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_databases => /v1/databases(.:format)
  // function(options)
  v1_databases_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"databases",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_deletion_impact => /v1/deletion_impact(.:format)
  // function(options)
  v1_deletion_impact_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"deletion_impact",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_disclaimer => /v1/disclaimer(.:format)
  // function(options)
  v1_disclaimer_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"disclaimer",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_export => /v1/export(.:format)
  // function(options)
  v1_export_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"export",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_health => /v1/health(.:format)
  // function(options)
  v1_health_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"health",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_internal_account => /v1/internal/account(.:format)
  // function(options)
  v1_internal_account_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"internal",false],[2,[7,"/",false],[2,[6,"account",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_patient => /v1/patients/:id(.:format)
  // function(id, options)
  v1_patient_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"patients",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_patient_consent => /v1/patient_consent(.:format)
  // function(options)
  v1_patient_consent_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"patient_consent",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_patient_therapies => /v1/patients/:patient_id/therapies(.:format)
  // function(patient_id, options)
  v1_patient_therapies_path: Utils.route([["patient_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"patients",false],[2,[7,"/",false],[2,[3,"patient_id",false],[2,[7,"/",false],[2,[6,"therapies",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_public_round => /v1/public/rounds/:token(.:format)
  // function(token, options)
  v1_public_round_path: Utils.route([["token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"public",false],[2,[7,"/",false],[2,[6,"rounds",false],[2,[7,"/",false],[2,[3,"token",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_public_round_answers => /v1/public/rounds/:token/answers(.:format)
  // function(token, options)
  v1_public_round_answers_path: Utils.route([["token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"public",false],[2,[7,"/",false],[2,[6,"rounds",false],[2,[7,"/",false],[2,[3,"token",false],[2,[7,"/",false],[2,[6,"answers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_public_round_complete => /v1/public/rounds/:token/complete(.:format)
  // function(token, options)
  v1_public_round_complete_path: Utils.route([["token",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"public",false],[2,[7,"/",false],[2,[6,"rounds",false],[2,[7,"/",false],[2,[3,"token",false],[2,[7,"/",false],[2,[6,"complete",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]),
// v1_subscription_requests => /v1/subscription_requests(.:format)
  // function(options)
  v1_subscription_requests_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// v1_survey => /v1/surveys/:id(.:format)
  // function(id, options)
  v1_survey_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_survey_answers_groups => /v1/surveys/:survey_id/answers_groups(.:format)
  // function(survey_id, options)
  v1_survey_answers_groups_path: Utils.route([["survey_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[3,"survey_id",false],[2,[7,"/",false],[2,[6,"answers_groups",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_survey_update_bookmark => /v1/surveys/:survey_id/update_bookmark(.:format)
  // function(survey_id, options)
  v1_survey_update_bookmark_path: Utils.route([["survey_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"surveys",false],[2,[7,"/",false],[2,[3,"survey_id",false],[2,[7,"/",false],[2,[6,"update_bookmark",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// v1_tenant_config => /v1/tenant/config(.:format)
  // function(options)
  v1_tenant_config_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"tenant",false],[2,[7,"/",false],[2,[6,"config",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_therapy => /v1/therapies/:id(.:format)
  // function(id, options)
  v1_therapy_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"therapies",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// v1_webhooks_whatsapp => /v1/webhooks/whatsapp(.:format)
  // function(options)
  v1_webhooks_whatsapp_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"webhooks",false],[2,[7,"/",false],[2,[6,"whatsapp",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
// validate_confirmation => /confirmations/validate(.:format)
  // function(options)
  validate_confirmation_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"confirmations",false],[2,[7,"/",false],[2,[6,"validate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
// validate_email_v1_subscription_request => /v1/subscription_requests/:id/validate_email(.:format)
  // function(id, options)
  validate_email_v1_subscription_request_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"subscription_requests",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"validate_email",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
// validate_request => /validate_request(.:format)
  // function(options)
  validate_request_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"validate_request",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
// validate_v1_admin_database_formula => /v1/admin/databases/:database_id/formula/validate(.:format)
  // function(database_id, options)
  validate_v1_admin_database_formula_path: Utils.route([["database_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"v1",false],[2,[7,"/",false],[2,[6,"admin",false],[2,[7,"/",false],[2,[6,"databases",false],[2,[7,"/",false],[2,[3,"database_id",false],[2,[7,"/",false],[2,[6,"formula",false],[2,[7,"/",false],[2,[6,"validate",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]]]]])}
;
      routes.configure = function(config) {
        return Utils.configure(config);
      };
      routes.config = function() {
        return Utils.config();
      };
      Object.defineProperty(routes, 'defaults', {
        get: function() {
          throw new Error("Routes" + ".defaults is removed. Use " + "Routes" + ".configure() instead.");
        },
        set: function(value) {}
      });
      routes.default_serializer = function(object, prefix) {
        return Utils.default_serializer(object, prefix);
      };
      return Utils.namespace(root, "Routes", routes);
    }
  };

  result = Utils.make();

  if (typeof define === "function" && define.amd) {
    define([], function() {
      return result;
    });
  }

  return result;

}).call(this);

